/** Max width of the guide text column — hero copy, section headers, and section intros — kept in sync across all guide pages. */
export const GUIDE_TEXT_MAX_WIDTH = '540px';

/** Width of the aside card column beside guide section content, once the container is wide enough for two columns. */
export const GUIDE_ASIDE_WIDTH = '360px';
